import React, {useEffect, useState} from "react";
import styles from "./platform.module.css";
import classes from "./Settings.module.css";
import {useHistory} from "react-router-dom";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {
    BG_IMAGE_PREVIEW_ALT,
    LOGIN_PAGE_BRANDING_DESC,
    LOGIN_PAGE_BRANDING, CHOOSE_FILE_TEXT, LOGIN_BG_IMG_TEXT, LOGIN_LOGO_TEXT, LOGO_IMAGE_PREVIEW_ALT,
    ROLES,
    TEXTBOX, UPLOAD_BG_IMAGE_DESC,
    UPLOAD_IMAGE_ERROR, UPLOAD_LOGO_IMAGE_DESC, UPLOAD_IMAGE_TEXT
} from "../../utils/constants";
import {notifyError} from "../../utils/helpers";
import useHostname from "../../hooks/useHostname";
import YuJaButton from "../../components/standardization/YuJaButton";
import { ReactComponent as YuJaLogo } from "../../images/yujalogo.svg";
import { ReactComponent as BRANDING_ICON } from "../../images/branding_color.svg";

export default function BrandingTab({bgImgUrl, setBgImgUrl, logoImgUrl, setLogoImgUrl}) {
    const history = useHistory();
    const [, getSession] = useLocalStorageNew("session", {});
    const {imageURL, logoImageURL} = useHostname(window.location.hostname);
    const imageSuffixArr = ['.png', '.jfif', '.pjpeg', '.jpg', '.jpeg', '.pjp'];
    const [bgImageUploadedFile, setBgImageUploadedFile] = useState("");
    const [bgImgUploadedFileURL, setBgImgUploadedFileURL] = useState("");
    const [logoImageUploadedFile, setLogoImageUploadedFile] = useState("");
    const [logoImgUploadedFileURL, setLogoImgUploadedFileURL] = useState("");

    useEffect(() => {
        const {role = ''} = getSession();
        if (role !== ROLES.ADMINISTRATOR.value && role !== ROLES.IT_MANAGER.value) {
            history.push({
                pathname: "/"
            });
            return;
        }


        setBgImgUrl(imageURL ? imageURL : "");
        setLogoImgUrl(logoImageURL ? logoImageURL : "");
    }, []);

    const uploadBG = (e) => {
        const suffix = e.target.value.substring(e.target.value.lastIndexOf("."));
        if (!imageSuffixArr.includes(suffix)) {
            e.target.value = null;
            notifyError(UPLOAD_IMAGE_ERROR);
        }
        setBgImageUploadedFile(e.target.files[0].name);
        setBgImgUploadedFileURL(URL.createObjectURL(e.target.files[0]));
    };

    const uploadLogo = (e) => {
        const suffix = e.target.value.substring(e.target.value.lastIndexOf("."));
        if (!imageSuffixArr.includes(suffix)) {
            e.target.value = null;
            notifyError(UPLOAD_IMAGE_ERROR);
        }
        setLogoImageUploadedFile(e.target.files[0].name);
        setLogoImgUploadedFileURL(URL.createObjectURL(e.target.files[0]));
    };

    return (
        <div className={classes.cardBox} style={{flex: 1}}>
            <div className={classes.cardBoxHeader}>
                <BRANDING_ICON />
                <span>{LOGIN_PAGE_BRANDING}</span>
            </div>
            <div className={classes.cardBoxBody}>
                <div className={classes.cardDescription}>{LOGIN_PAGE_BRANDING_DESC}</div>
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    minHeight: 80,
                    width: "100%",
                    gap: 20,
                    marginTop: 15
                }}>
                    <div style={{display: "flex", flexDirection: "column", gap: 15, height: "fit-content", width: 250}}>
                        <div className={classes.settingLabel}>{LOGIN_LOGO_TEXT} </div>
                        <input id="logo-file-input" type="file" accept="image/png, image/jpeg" onChange={uploadLogo}/>
                        <YuJaButton htmlFor="logo-file-input" style={{whiteSpace: "nowrap"}}>{UPLOAD_IMAGE_TEXT}</YuJaButton>
                        <div className={classes.settingDescription}>{UPLOAD_LOGO_IMAGE_DESC}</div>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: 15}}>
                        <div className={classes.settingLabel}>{"Preview"} </div>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 150,
                            height: 67,
                            backgroundColor: "#c8c7c7",
                            borderRadius: 6
                        }}>
                            {(!!logoImgUrl || !!logoImgUploadedFileURL)
                                ?
                                <img
                                    className={styles.previewLogo}
                                    src={!!logoImgUploadedFileURL ? logoImgUploadedFileURL : logoImgUrl}
                                    alt={LOGO_IMAGE_PREVIEW_ALT}
                                />
                                :
                                <YuJaLogo/>
                            }


                        </div>
                        {!!logoImageUploadedFile &&
                            <div style={{marginTop: "10px"}}> {logoImageUploadedFile} </div>
                        }
                    </div>
                </div>


                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    minHeight: 300,
                    width: "100%",
                    gap: 20,
                    marginTop: 15
                }}>
                    <div style={{display: "flex", flexDirection: "column", gap: 15, height: "fit-content", width: 250}}>
                        <div className={classes.settingLabel}>{LOGIN_BG_IMG_TEXT}</div>
                        <input id="bg-file-input" type="file" accept="image/png, image/jpeg" onChange={uploadBG}/>
                        <YuJaButton htmlFor="bg-file-input" style={{whiteSpace: "nowrap"}}>{UPLOAD_IMAGE_TEXT}</YuJaButton>
                        <div className={classes.settingDescription}>{UPLOAD_BG_IMAGE_DESC}</div>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", gap: 15}}>
                        <div className={classes.settingLabel}>{"Preview"} </div>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 450,
                            height: 260,
                            backgroundColor: "#c8c7c7",
                            borderRadius: 6
                        }}>
                            {(!!bgImgUrl || !!bgImgUploadedFileURL)
                                ?
                                <img
                                    className={styles.previewBG}
                                    src={!!bgImgUploadedFileURL ? bgImgUploadedFileURL : bgImgUrl}
                                    alt={BG_IMAGE_PREVIEW_ALT}
                                />
                                :
                                <div className={styles.defaultBG}/>
                            }

                        </div>
                        {!!bgImageUploadedFile &&
                            <div style={{marginTop: "10px"}}> {bgImageUploadedFile} </div>
                        }
                    </div>
                </div>
            </div>
        </div>

    );
};
